<div class="tem-field content-container">
  <label class="tem-field-label">Informar nome do Filtro</label>
  <nz-input-group [nzSuffix]="clearTpl">
    <input nz-input type="text" [formControl]="fillControl">
  </nz-input-group>
  <ng-template #clearTpl>
    <nz-icon *ngIf="fillControl.value" nzType="close-circle" class="clear-icon" (click)="fillControl.setValue('')"></nz-icon>
  </ng-template>
  <div class="field-error" *ngIf="fillControl.touched && fillControl.hasError('required')">
    Nome do filtro é <strong>obrigatório</strong>
  </div>
</div>
<div class="button-class">
  <button nz-button id="no-button" nzDanger (click)="closeDialog()">Cancelar</button>
  <button nz-button id="yes-button" nzType="primary" (click)="salvar()">Salvar</button>
</div>
